module.exports = __webpack_public_path__ + "media/categories/2048-e99ae428.svg";